import { apiClient } from './client'

export const configService = {
  getStore() {
    return apiClient.get('/config/store')
  },
  updateStore(payload) {
    return apiClient.put('/config/store', payload)
  },
  getRoles() {
    return apiClient.get('/config/roles')
  },
  getPermissions() {
    return apiClient.get('/config/permissions')
  },
  getUsers() {
    return apiClient.get('/config/users')
  },
  inviteUser(payload) {
    return apiClient.post('/config/users', payload)
  },
  updateUser(id, payload) {
    return apiClient.put(`/config/users/${id}`, payload)
  },
  deleteUser(id) {
    return apiClient.delete(`/config/users/${id}`)
  },
  createRole(payload) {
    return apiClient.post('/config/roles', payload)
  },
  updateRole(id, payload) {
    return apiClient.put(`/config/roles/${id}`, payload)
  },
  deleteRole(id) {
    return apiClient.delete(`/config/roles/${id}`)
  }
}
